module.exports = __webpack_public_path__ + "static/media/pt4.52ffedbd.jpg";